import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
// hooks
import useAuth from '../hooks/useAuth';
// routes
import { PATH_GROUPS, PATH_MY_PROFILE, PATH_REPORTS } from '../routes/paths';

// ----------------------------------------------------------------------

AdminGuestGuard.propTypes = {
  children: PropTypes.node,
};

export default function AdminGuestGuard({ children }) {
  const { isAuthenticated, user } = useAuth();

  if (isAuthenticated) {
    return <Navigate to={user?.role !== 'admin' ? '/admin/campaign' : '/404'} />;
  }

  return <>{children}</>;
}
